module.exports = __webpack_public_path__ + "img/2.f4ea3e1a.png";